// extracted by mini-css-extract-plugin
export default {"postThing":"Post_postThing__N-7M2","postThingPub":"Post_postThingPub__tnGl4","postBlog":"Post_postBlog__B4CZX","title":"Post_title__af5EM"};